import { useState } from 'react';
import DatePicker from "react-datepicker";
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import Icon from './Icon';
import Label from './form/Label';

const GenericDatePicker = ({
    initialValue,
    label,
    labelComponent,
    onChange,
    css = {},
    dateFormat = 'dd-MMM-yyyy HH:mm',
    tooltip,
    buttonTooltip,
    showTimeSelect = true,
    isRequired = false,
    ...props
}) => {
    const [value, setValue] = useState(initialValue);
    const [translate] = useTranslation();

    return (
        <div>
            <Label
                controlId={props.id || props.name}
                label={label}
                labelComponent={labelComponent}
                tooltip={tooltip}
                buttonTooltip={buttonTooltip}
                isRequired={isRequired}
            />
            <div className='d-flex flex-wrap-1 align-items-center date-picker-w-100'>
                <DatePicker
                    selected={value}
                    onChange={(newDate) => {
                        setValue(newDate);

                        if (onChange) {
                            onChange(newDate);
                        }
                    }}
                    showTimeSelect={showTimeSelect}
                    dateFormat={dateFormat}
                    className={`form-control ${css.input}`}
                    {...props}
                />
                <Button
                    variant="outline-danger"
                    className="ms-2 p-0 border-0"
                    onClick={() => {
                        setValue(null);

                        if (onChange) {
                            onChange(null);
                        }
                    }}
                    title={translate("Clear")}
                >
                    <Icon icon="Clear" className="d-block" />
                </Button>
            </div>
        </div>
    );
};

export default GenericDatePicker;